module.exports = __webpack_public_path__ + "static/media/ic-angle-right-darker.30923a94.svg";